"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExpandSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M19.41 1.54l9.83-.1a1.13 1.13 0 01.79.35 1.08 1.08 0 01.34.78l-.1 9.87a1.07 1.07 0 01-1.06 1.06 1 1 0 01-1.05-1.05L28.24 5l-8.81 8.84A1 1 0 1118 12.4l8.83-8.82-7.45.08a1 1 0 01-1.05-1.05 1.08 1.08 0 011.08-1.07zm-5.75 27.85a1 1 0 00-1.05-1.05l-7.45.08L14 19.6a1 1 0 10-1.42-1.42L3.76 27l.08-7.47a1 1 0 00-1-1.05 1.07 1.07 0 00-1.06 1.06l-.1 9.87a1.08 1.08 0 00.34.78 1.13 1.13 0 00.79.35l9.83-.1a1.08 1.08 0 001.02-1.05z"/><path d="M2.77 31.56a2.19 2.19 0 01-1.5-.64 2.09 2.09 0 01-.64-1.5l.1-9.87a2.08 2.08 0 012.05-2.05 2 2 0 012 2.05v5l7.08-7.1a2 2 0 012.82 0 2 2 0 01.59 1.41 2 2 0 01-.59 1.42L7.6 27.4l5-.06a2 2 0 011.46.6 2 2 0 01.6 1.46 2.08 2.08 0 01-2.06 2.06zm0-12a.05.05 0 000 .05l-.1 9.87c.09.11.1.11.19.12l9.76-.1a.09.09 0 00.08-.08l-9.91.12v-2.46l.08-7.47zm15.94-4.41a2 2 0 01-1.41-.59 1.94 1.94 0 01-.59-1.4 2 2 0 01.59-1.43l7.1-7.13-5 .06a2 2 0 01-2.06-2.06A2.09 2.09 0 0119.4.54l9.83-.1a2.19 2.19 0 011.5.64 2.09 2.09 0 01.64 1.5l-.1 9.86a2.08 2.08 0 01-2.05 2.06 2.05 2.05 0 01-1.44-.59 2 2 0 01-.59-1.47l.05-5-7.08 7.1a2 2 0 01-1.44.57zM29.26 2.57l-.1 9.89h.11l.1-9.86c-.09-.11-.1-.11-.19-.12l-9.76.1a.09.09 0 00-.08.08l9.92-.09z"/>';
var ExpandSVG = function ExpandSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ExpandSVG = ExpandSVG;
ExpandSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ExpandSVG);
exports.default = _default;